document.addEventListener('DOMContentLoaded', () => {
  const viewer = document.getElementById('etbViewer');
  const colorDots = document.querySelectorAll('.color-dot');
  const etbContainer = document.getElementById('etbGrid'); // updated
  const showEtbsBtn = document.getElementById('etbToggleBtn'); // updated
  const etbSearch = document.getElementById('etb-search');
  let currentColor = '#FFFFFF';

  function hexToRgba(hex, alpha = 1.0) {
    const r = parseInt(hex.slice(1, 3), 16) / 255;
    const g = parseInt(hex.slice(3, 5), 16) / 255;
    const b = parseInt(hex.slice(5, 7), 16) / 255;
    return [r, g, b, alpha];
  }

  function updateCaseCoverColor(hex) {
    const rgba = hexToRgba(hex);
    const casecoverMaterial = viewer.model?.materials.find(
      (mat) => mat.name.toLowerCase().includes('casecover')
    );
    if (casecoverMaterial && casecoverMaterial.pbrMetallicRoughness) {
      casecoverMaterial.pbrMetallicRoughness.setBaseColorFactor(rgba);
    }
  }

  viewer.addEventListener('load', () => updateCaseCoverColor(currentColor));

  colorDots.forEach(dot => {
    dot.addEventListener('click', () => {
      currentColor = dot.dataset.color;
      if (viewer.model) {
        updateCaseCoverColor(currentColor);
      } else {
        viewer.addEventListener('load', () => updateCaseCoverColor(currentColor), { once: true });
      }
    });
  });

  showEtbsBtn.addEventListener('click', () => {
    etbContainer.classList.toggle('visible');
  });

  etbSearch.addEventListener('input', () => {
    const query = etbSearch.value.toLowerCase();
    etbContainer.querySelectorAll('.etb-thumb').forEach((thumb) => {
      const label = thumb.querySelector('p').textContent.toLowerCase();
      thumb.style.display = label.includes(query) ? 'block' : 'none';
    });
  });

  etbContainer.addEventListener('click', (e) => {
    const thumb = e.target.closest('.etb-thumb');
    if (!thumb) return;
    const newSrc = thumb.dataset.src;
    if (newSrc && viewer.getAttribute('src') !== newSrc) {
      viewer.setAttribute('src', newSrc);
      viewer.addEventListener('load', () => updateCaseCoverColor(currentColor), { once: true });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  });
});
